import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConfigService } from '../../_services/config.service';
import { Location } from '@angular/common';
import { CompaniesService } from '../services/companies.service';
import { CalendarOptions } from '@fullcalendar/core/index.js';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Button } from 'src/app/_models/modal/Button';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalKcsComponent } from 'src/app/_directives/modal/kcs-modal';
@Component({
  standalone: false,
	selector: 'app-lista-appuntamenti',
	templateUrl: 'lista-appuntamenti.component.html',
	styleUrls: ['lista-appuntamenti.component.css'],
})
export class ListaAppuntamentiComponent implements OnInit {
	@Input() cmp_id!: number;
	events: any[] = [];
	my_user: any = {};
	visible = false;
	tipo_utenza = false;
	curr_mese = 0;
	curr_anno = 0;
	appuntamento: any;
	//settings_companies_appointment: any = {};
	company_calendar: any = {};
	calendario_obj: any = {};

	guid=''

	days = [
		{ value: '1', label: 'Lunedì' },
		{ value: '2', label: 'Martedì' },
		{ value: '3', label: 'Mercoledì' },
		{ value: '4', label: 'Giovedì' },
		{ value: '5', label: 'Venerdì' },
		{ value: '6', label: 'Sabato' },
		{ value: '0', label: 'Domenica' },
	];
	sub: Subscription = new Subscription();

	@ViewChild('modalCompanyCalendar') modalCompanyCalendar!: TemplateRef<any>;
	modalButtons: Button[] = [];

	date_da_obj: Date | null = null;
	date_a_obj: Date | null = null;
	intervalliOscurati: { da: Date; a: Date }[] = [];

	constructor(private route: ActivatedRoute, private config: ConfigService, private companiesManager: CompaniesService, private location: Location, private modalService: NgbModal) {}
	ngOnInit(): void {
		this.my_user = this.config.getUser();
		this.tipo_utenza = this.config.isUserSuperAdmin();
		this.sub = this.route.params.subscribe((params) => {
			this.cmp_id = +params['id'];
		});
		this.calendario_obj = {};
		this.calendario_obj.giorni_settimana = [];
	}

	calendarOptions: CalendarOptions = {
		plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
		initialView: 'listWeek',
		headerToolbar: {
			left: 'prev,next today',
			center: 'title',
			right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
		},
		height: 'auto',
		slotMinTime: '07:00:00', // orario inizio
		slotMaxTime: '22:00:00', // orario fine
		events: this.events,
		/*Clicco sul calendario e decido quando prendere appuntamento -> non più utilizzato*/
		// dateClick: this.handleDateClick.bind(this),
		eventClick: this.handleEventClick.bind(this),
		eventMouseEnter: this.handleEventMouseEnter.bind(this),
		datesSet: this.handleDatesSet.bind(this),
	};

	handleEventMouseEnter(info: any) {
		const start = new Date(info.event.start);
		const end = new Date(info.event.end);

		const durationInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);

		info.el.setAttribute('title', `${info.event.title} - Durata: ${durationInMinutes} minuti`);
	}

	async handleEventClick(info: any) {
		this.appuntamento = JSON.parse(JSON.stringify(info.event));
		this.visible = true;
	}

	handleDatesSet(event: any) {
		const viewStart = event.view.currentStart;

		this.curr_mese = viewStart.getMonth() + 1;
		this.curr_anno = viewStart.getFullYear();

		/*if (this.tipo_utenza === 'ADMIN') {
        this.getSettingsCompaniesAppointment();
      } else {
        this.getAppointmentsList();
        this.getSettingsCompaniesAppointment();
      }*/
		this.getSettingsCompaniesAppointment();
	}

	getSettingsCompaniesAppointment() {
		if (this.cmp_id > 0) {
			this.companiesManager.getSettingsCompaniesAppointment(this.cmp_id).subscribe((data: any) => {
				if (data) {
					this.company_calendar = data;

					if (this.company_calendar.calendario) {
						this.calendario_obj = JSON.parse(this.company_calendar.calendario.trim());
						// Converti i campi orari in oggetti Date
						this.calendario_obj.mattina_inizio = this.parseTimeToDate(this.calendario_obj.mattina_inizio);
						this.calendario_obj.mattina_fine = this.parseTimeToDate(this.calendario_obj.mattina_fine);
						this.calendario_obj.pomeriggio_inizio = this.parseTimeToDate(this.calendario_obj.pomeriggio_inizio);
						this.calendario_obj.pomeriggio_fine = this.parseTimeToDate(this.calendario_obj.pomeriggio_fine);
					} else {
						this.company_calendar.calendario = {};
						this.calendario_obj = {};
						this.calendario_obj.giorni_settimana = [];
					}

					if (this.company_calendar.calendario_no_work) {
						this.intervalliOscurati = JSON.parse(this.company_calendar.calendario_no_work.trim());
					} else {
						this.intervalliOscurati = [];
					}

					//this.settings_companies_appointment = JSON.parse(data.res);
					if (this.company_calendar.calendario) {
						this.getAppointmentsList();
					} else {
						this.config.openErrorNotify("Nessun orario di appuntamento dell'azienda disponibile");
					}
				}
			});
		}
	}

	getAppointmentsList() {
		let filter: any = {};
		filter.pagina = 1;
		filter.righePagina = 10000;
		filter.orderBy = 'apt_app_id DESC';
		filter.cmp_id = this.cmp_id;
		this.events = [];
		let slot_disponibili: any[] = [];

		if (!this.tipo_utenza) {
			let array_days = this.getDaysInMonthWithWeekdays(this.curr_anno, this.curr_mese, this.calendario_obj.giorni_settimana, this.intervalliOscurati);

			slot_disponibili = this.creaSlotAppuntamento(array_days, this.curr_anno, this.curr_mese, this.calendario_obj.mattina_inizio, this.calendario_obj.mattina_fine, this.calendario_obj.pomeriggio_inizio, this.calendario_obj.pomeriggio_fine);
		}

		this.companiesManager.getAppointmentsList(filter).subscribe((res: any) => {
			if (res) {
				for (let i = 0; i < res.length; i++) {
					switch (res[i].stato.id) {
						case 1:
							res[i].backgroundColor = 'blue';
							break;
						case 2:
							res[i].backgroundColor = 'green';
							break;
						case 3:
							res[i].backgroundColor = 'red';
							break;
					}

					if (!this.tipo_utenza) {
						if (this.my_user.usr_id != res[i].usr_id) {
							res[i].title = 'Slot Occupato';
							res[i].backgroundColor = 'red';
						}
					}
				}

				if (!this.tipo_utenza) {
					this.events = this.sostituisciSlotFittizi(slot_disponibili, res);
				} else {
					this.events = res;
				}

				this.calendarOptions.events = [...this.events];
			}
		});
	}

	getDaysInMonthWithWeekdays(year: number, month: number, giorniAppuntamento: string[], giorniFerie: { da: Date; a: Date }[]) {
		// Ottieni il numero di giorni nel mese specificato
		const daysInMonth = new Date(year, month, 0).getDate();

		// Data di oggi e di domani
		const today = new Date();
		const tomorrow = new Date(today);
		tomorrow.setDate(today.getDate() + 1);

		const ferieSet = new Set<string>();
		for (const intervallo of giorniFerie) {
			const start = new Date(intervallo.da);
			const end = new Date(intervallo.a);
			let current = new Date(start);
			/*let current = new Date(intervallo.da);
        const end = intervallo.a;*/

			while (current <= end) {
				ferieSet.add(current.toDateString());
				current.setDate(current.getDate() + 1);
			}
		}

		// Genera un array di oggetti contenenti giorno, nome del giorno e la data completa
		return Array.from({ length: daysInMonth }, (_, i) => {
			const date = new Date(year, month - 1, i + 1); // Usa month-1 perché i mesi in JavaScript partono da 0
			const weekdayIndex = date.getDay(); // Ottieni l'indice del giorno della settimana (0 per Domenica, 1 per Lunedì, ecc.)

			return { day: i + 1, fullDate: date, weekdayIndex };
		}).filter((dayObj) => {
			// Filtra solo i giorni successivi a domani e compatibili con `giorniAppuntamento` e `giorniFerie`
			const isAfterTomorrow = dayObj.fullDate >= tomorrow;
			const isAllowedWeekday = giorniAppuntamento.includes(dayObj.weekdayIndex.toString());
			const isNotHoliday = !ferieSet.has(dayObj.fullDate.toDateString());

			return isAfterTomorrow && isAllowedWeekday && isNotHoliday;
		});
	}

	creaSlotAppuntamento(daysArray: any, year: number, month: number, mattina_inizio: number, mattina_fine: number, pomeriggio_inizio: number, pomeriggio_fine: number) {
		const result: any[] = [];

		// Ottieni ora e minuti per mattina e pomeriggio
		let mattina_inizio_ore = new Date(mattina_inizio).getHours();
		let mattina_inizio_minuti = new Date(mattina_inizio).getMinutes();

		let mattina_fine_ore = new Date(mattina_fine).getHours();
		let mattina_fine_minuti = new Date(mattina_fine).getMinutes();

		let pomeriggio_inizio_ore = new Date(pomeriggio_inizio).getHours();
		let pomeriggio_inizio_minuti = new Date(pomeriggio_inizio).getMinutes();

		let pomeriggio_fine_ore = new Date(pomeriggio_fine).getHours();
		let pomeriggio_fine_minuti = new Date(pomeriggio_fine).getMinutes();

		daysArray.forEach((dayObj: any) => {
			const { day } = dayObj;

			// Slot mattutini
			for (let hour = mattina_inizio_ore; hour <= mattina_fine_ore; hour++) {
				for (let minute = hour === mattina_inizio_ore ? mattina_inizio_minuti : 0; minute < 60; minute += 30) {
					// Verifica se siamo nell'ultimo slot mattutino e crea l'ultimo slot completo
					if (hour === mattina_fine_ore && minute === mattina_fine_minuti) {
						result.push(this.creaSlot(year, month, day, hour, minute, hour, minute + 30));
						break;
					}
					if (hour === mattina_fine_ore && minute > mattina_fine_minuti) break;
					result.push(this.creaSlot(year, month, day, hour, minute, hour, minute + 30));
				}
			}

			// Slot pomeridiani
			for (let hour = pomeriggio_inizio_ore; hour <= pomeriggio_fine_ore; hour++) {
				for (let minute = hour === pomeriggio_inizio_ore ? pomeriggio_inizio_minuti : 0; minute < 60; minute += 30) {
					// Verifica se siamo nell'ultimo slot pomeridiano e crea l'ultimo slot completo
					if (hour === pomeriggio_fine_ore && minute === pomeriggio_fine_minuti) {
						result.push(this.creaSlot(year, month, day, hour, minute, hour, minute + 30));
						break;
					}
					if (hour === pomeriggio_fine_ore && minute > pomeriggio_fine_minuti) break;
					result.push(this.creaSlot(year, month, day, hour, minute, hour, minute + 30));
				}
			}
		});

		return result;
	}

	creaSlot(year: number, month: number, day: number, startHour: number, startMinute: number, endHour: number, endMinute: number) {
		const start = new Date(year, month - 1, day, startHour, startMinute, 0);
		const end = new Date(year, month - 1, day, endHour, endMinute, 0);

		let slot = {
			title: 'Slot Disponibile',
			start: start.toISOString(),
			end: end.toISOString(),
			backgroundColor: 'green',
			commessa: { id: -1 },
		};

		return slot;
	}

	sostituisciSlotFittizi(conto: any, appuntamenti: any) {
		const mappaAppuntamenti = new Map<string, any>();

		appuntamenti.forEach((appuntamento: any) => {
			const key = `${appuntamento.start}-${appuntamento.end}`;
			mappaAppuntamenti.set(key, appuntamento);
		});

		// Aggiorna gli slot fittizi con quelli reali
		const risultato = conto.map((slotFittizio: any) => {
			const key = `${new Date(slotFittizio.start).getTime()}-${new Date(slotFittizio.end).getTime()}`;

			if (mappaAppuntamenti.has(key)) {
				const appuntamentoReale = mappaAppuntamenti.get(key);
				return appuntamentoReale;
			} else {
				return slotFittizio;
			}
		});

		return risultato;
	}

	/* close(): void {
      this.dialog.close('reload');
    } */

	isVisible(event: any) {
		this.visible = event;
		if (!this.tipo_utenza) {
			this.getSettingsCompaniesAppointment();
		} else {
			this.getAppointmentsList();
		}
	}

	OpenImpostaSlot() {
		if (this.calendario_obj) {
			this.modalButtons = [];

			this.modalButtons = [
				{ label: 'Annulla', class: 'kcs-button-outlined', action: () => this.closeModal() },
				{ label: 'Salva', class: 'kcs-button-outlined', action: () => this.saveCompanyCalendar() },
			];

			const modalRef = this.modalService.open(ModalKcsComponent, {
				ariaLabelledBy: 'modal-title',
				size: 'xl',
			});
			let title = 'Gestione Calendario';

			modalRef.componentInstance.openModal(title, '', this.modalButtons, 'primary', this.modalCompanyCalendar);
			modalRef.result.then(() => {});
		}
	}

	closeModal() {
		this.modalService.dismissAll();
	}

	/* set_giorni_settimana(ev: any) {
      this.calendario_obj.giorni_settimana = ev.target.value;
    } */

	setTimeOutMorningStart(newValue: Date) {
		if (this.calendario_obj.mattina_fine) {
			const startTime = new Date(newValue);
			const endTime = new Date(this.calendario_obj.mattina_fine);
			if (startTime.getTime() > endTime.getTime()) {
				this.config.openErrorNotify('Orario inizio maggiore di orario fine!');
				return;
			}
		}
	}

	setTimeOutMorningEnd(newValue: Date) {
		if (this.calendario_obj.mattina_inizio) {
			const startTime = new Date(this.calendario_obj.mattina_inizio);
			const endTime = new Date(newValue);
			if (startTime.getTime() > endTime.getTime()) {
				this.config.openErrorNotify('Orario fine minore di orario inizio!');
				return;
			}
		}
	}

	setTimeOutAfternoonStart(newValue: Date) {
		if (this.calendario_obj.pomeriggio_fine) {
			const startTime = new Date(newValue);
			const endTime = new Date(this.calendario_obj.pomeriggio_fine);
			if (startTime.getTime() > endTime.getTime()) {
				this.config.openErrorNotify('Orario inizio maggiore di orario fine!');
				return;
			}
		}
	}

	setTimeOutAfternoonEnd(newValue: Date) {
		if (this.calendario_obj.pomeriggio_inizio) {
			const startTime = new Date(this.calendario_obj.pomeriggio_inizio);
			const endTime = new Date(newValue);
			if (startTime.getTime() > endTime.getTime()) {
				this.config.openErrorNotify('Orario fine minore di orario inizio!');
				return;
			}
		}
	}

	/*getCompanyCalendar() {
      this.companiesManager.getCompanyCalendar(this.cmp_id).subscribe((data: any) => {
        if (data) {
          this.company_calendar = data;

          if (this.company_calendar.calendario) {
            this.calendario_obj = JSON.parse(this.company_calendar.calendario.trim());
            // Converti i campi orari in oggetti Date
            this.calendario_obj.mattina_inizio = this.parseTimeToDate(this.calendario_obj.mattina_inizio);
            this.calendario_obj.mattina_fine = this.parseTimeToDate(this.calendario_obj.mattina_fine);
            this.calendario_obj.pomeriggio_inizio = this.parseTimeToDate(this.calendario_obj.pomeriggio_inizio);
            this.calendario_obj.pomeriggio_fine = this.parseTimeToDate(this.calendario_obj.pomeriggio_fine);
          } else {
            this.company_calendar.calendario = {};
            this.calendario_obj = {};
            this.calendario_obj.giorni_settimana = [];
          }

          if (this.company_calendar.calendario_no_work) {
            this.intervalliOscurati = JSON.parse(this.company_calendar.calendario_no_work.trim());
          } else {
            this.intervalliOscurati = [];
          }

          // Forza il rilevamento dei cambiamenti
          //this.cdr.detectChanges();
        }
      });
    }*/

	parseTimeToDate(isoString: string): Date {
		if (!isoString) return new Date();
		const date = new Date(isoString);
		const time = new Date();
		time.setHours(date.getHours(), date.getMinutes(), 0, 0);
		return time;
	}

	saveCompanyCalendar() {
		if (this.calendario_obj) {
			const calendarioToSave = {
				...this.calendario_obj,
				mattina_inizio: this.calendario_obj.mattina_inizio ? this.formatDateToISOString(this.calendario_obj.mattina_inizio) : null,
				mattina_fine: this.calendario_obj.mattina_fine ? this.formatDateToISOString(this.calendario_obj.mattina_fine) : null,
				pomeriggio_inizio: this.calendario_obj.pomeriggio_inizio ? this.formatDateToISOString(this.calendario_obj.pomeriggio_inizio) : null,
				pomeriggio_fine: this.calendario_obj.pomeriggio_fine ? this.formatDateToISOString(this.calendario_obj.pomeriggio_fine) : null,
			};
			this.company_calendar.calendario = JSON.stringify(calendarioToSave);
		}
		if (this.intervalliOscurati && this.intervalliOscurati.length > 0) {
			this.company_calendar.calendario_no_work = JSON.stringify(this.intervalliOscurati);
		}
		this.companiesManager.saveCompanyCalendar(this.cmp_id, this.company_calendar).subscribe((data: any) => {
			if (data > 0) {
				this.config.openSuccessNotify('Calendario Azienda modificato correttamente');
			}
		});
	}

	formatDateToISOString(date: Date): string | null {
		if (!date) return null;
		const year = 2025;
		const month = 0;
		const day = 1;
		return new Date(year, month, day, date.getHours(), date.getMinutes()).toISOString();
	}

	setDataOscurareStart(newDate: any | null) {
		this.date_da_obj = newDate;
	}

	setDataOscurareEnd(newDate: any | null) {
		this.date_a_obj = newDate;
	}

	aggiungiIntervalloOscurato() {
		if (this.date_da_obj && this.date_a_obj && this.date_da_obj <= this.date_a_obj) {
			this.intervalliOscurati.push({
				da: this.date_da_obj,
				a: this.date_a_obj,
			});
			this.date_da_obj = null;
			this.date_a_obj = null;
		} else {
			this.config.openErrorNotify('Intervallo non valido o date mancanti');
		}
	}

	rimuoviIntervallo(index: number) {
		this.intervalliOscurati.splice(index, 1);
	}

	goBack(): void {
		this.location.back();
	}
}
